export default "__VITE_ASSET__bCjgLWmB__"